import React, { Component } from "react";
import { observer } from "mobx-react";
import { css } from "react-emotion";

class TelephoneString extends Component {
  render() {
    const { withSlash = true, phone = "999 994 312" } = this.props;
    const { styles } = this;

    return (
      <span className={styles.root}>
        040 {withSlash && "/"} {phone}
      </span>
    );
  }

  styles = {
    root: css`
      white-space: nowrap;
    `,
  };
}

TelephoneString = observer(TelephoneString);

export default TelephoneString;
export const rawTelephone = "040999994312";
